import { appendALExamTemplate } from '@/functions/idp'
import RIC from './RIC_8'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
